import styled from '@emotion/styled/macro';
import {theme} from '@themes';
import {colors} from '@assets/colors';

export const HeaderStyled = styled.header`
  position: fixed;
  z-index: 999;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  border-bottom: ${colors.gray3};
  height: 65px;
  filter: drop-shadow(0 10px 8px  rgba(0,0,0,.04)) drop-shadow(0 4px 3px rgba(0,0,0,.1));
  h2 {
    margin: 0;
    color: ${colors.black0};
    margin-top: 15px;
    margin-bottom: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${theme.breakpoints.down('sm')} {
      max-width: 320px;
    }
    ${theme.breakpoints.down('md')} {
      max-width: 520px;
    }
  }
  ${theme.breakpoints.up('xs')} {
    padding: 5px 24px 5px 24px;
  }
  ${theme.breakpoints.up('sm')} {
    padding: 10px 39px 10px 39px;
  }
  ${theme.breakpoints.up('md')} {
    padding: 15px 48px 15px 48px;
  }
`;
